module.exports = __webpack_public_path__ + "img/kaizhibaoxiao.71e18217.png";